interface Props {
  src: string;
}

/** Version sans fichier cadre externe : cadre visuel minimal pour le build agbaza. */
function IphoneFrame({ src }: Props) {
  return (
    <div className="relative h-full overflow-hidden rounded-[2rem] border-[10px] border-base-300 bg-base-200 shadow-xl">
      <img src={src} alt="screenshot" className="h-full w-full rounded-2xl object-cover" />
    </div>
  );
}

export default IphoneFrame;
